import { Component, InjectionToken, OnInit, inject } from '@angular/core';

import { ActivatedRoute, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { FooterComponent } from './shared/components/footer/footer.component';
import { NavigationComponent } from './shared/components/navigation/navigation.component';
import {
  BreadcrumbsService,
  IPathArray,
} from './shared/services/breadcrumbs.service';
import { PrimeNGConfig } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { register } from 'swiper/element/bundle';
import { AppUpdatesService } from './shared/services/app-updates.service';
import { ToastModule } from 'primeng/toast';
import { ApolloModule } from 'apollo-angular';
import { Platform } from '@angular/cdk/platform';
import { ProductDetailsHeaderComponent } from './shared/components/product/product-details-header/product-details-header.component';
import { AssetPreviewPipe } from './shared/pipes/asset-preview.pipe';
import { ButtonModule } from 'primeng/button';
import { RippleModule } from 'primeng/ripple';
import { StateService } from './core/state/old/state.service';
import { ActiveService } from './core/providers/active/active.service';
import { Customer } from './graphql/generated/generated-types';
import { environment } from '../environments/environment';
import { Loader } from '@googlemaps/js-api-loader';
import { NotificationComponent } from './shared/notification/notification.component';
import { VehicleTypeService } from './shared/services/vehicle-type.service';
import { SelectedModificationService } from './shared/services/selected-modification.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterOutlet,
    ApolloModule,
    NavigationComponent,
    FooterComponent,
    ToastModule,
    ProductDetailsHeaderComponent,
    AssetPreviewPipe,
    ButtonModule,
    RippleModule,
    NotificationComponent,
  ],
  providers: [DialogService, AppUpdatesService],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {

  constructor(
    private primengConfig: PrimeNGConfig,
    public breadcrumbsService: BreadcrumbsService,
    private stateService: StateService,
    private activeService: ActiveService,
    private platform: Platform,
    private appUpdateService: AppUpdatesService,
    private selectedModificationService: SelectedModificationService,
    private vehicleTypeService: VehicleTypeService
  ) {
    this.primengConfig.ripple = true;
    // Register Swiper.js
    register();
    // Check for new versions and update Service worker:
    this.appUpdateService.performAppUpdates();
    this.setVehicleInfoFromRoute();


  }

  ngOnInit(): void {
    if (this.platform.isBrowser) {
      this.getActiveCustomer();
      this.loadGoogleMaps();
    }


  }

  public setVehicleInfoFromRoute(){
    console.log('On init app component ts setting vehicle info')
    this.setActiveVehicleTypeFromRoute();
    this.setSelectedModificationFromUrl();

  }

  private loadGoogleMaps() {
    const loader = new Loader({
      apiKey: environment.googleMapsApiKey,
      version: 'weekly',
    });

    loader.importLibrary('maps');
  }
  private getActiveCustomer() {
    this.activeService.activeCustomer$.subscribe({
      next: (activeCustomer: Customer) => {
        if (activeCustomer) {
          this.stateService.setState('signedIn', true);
        }
      },
    });
  }
  public openCartSidenav() {
    this.stateService.setState('cartSidebarVisible', true);
  }

  private setActiveVehicleTypeFromRoute() {
    this.vehicleTypeService.setVehicleType();

  }

  private setSelectedModificationFromUrl() {
    this.selectedModificationService.setModificationId();
  }
}
